export default __webpack_public_path__ + "static/media/twitter.357dfec9.png";